define(function (require, exports, module) {
	'use strict';

	var $ = require('jquery');
	var BHtml = require('blocks-cloud/b-html/b-html');

	var Toolkit = {
		init: function () {
			// Необходимо выполнить шаблон b-toolkit.xml,
			// перед использованием BToolkit.initBlock()
			var bHtml = new BHtml({
				template: 'app',
				$el: $('<div/>'),
				data: {
					html: 'init'
				}
			});

			bHtml.render();
		}
	};

	module.exports = Toolkit;
});
